import { render, staticRenderFns } from "./CreateDispatch.vue?vue&type=template&id=5802d79c&scoped=true"
import script from "./CreateDispatch.vue?vue&type=script&lang=ts"
export * from "./CreateDispatch.vue?vue&type=script&lang=ts"
import style0 from "./CreateDispatch.vue?vue&type=style&index=0&id=5802d79c&prod&lang=css"
import style1 from "./CreateDispatch.vue?vue&type=style&index=1&id=5802d79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802d79c",
  null
  
)

export default component.exports